import React, { useEffect, useState, useRef } from 'react';

import Header from '../../Global/Header';
import { Link } from 'react-router-dom';

const AccountType = () => {

    const [state, setState] = useState(true)

    useEffect(() => {

        setTimeout(() => {
            setState(false)
        }, 300);

    }, [])

    return (
        <React.Fragment>
            <div className={`instructpg account-type ${state ? '' : 'active'}`}>
                <Header
                    innerPage={true}
                    title={'ویرایش حساب کاربری'} />

                <div className="body-courses">

                    <Link to="/myAccount/personalInfo" className="item-accountType">
                        <i className="icon-user-1-fill"></i>
                        <span>اطلاعات شخصی</span>
                        <i className="icon-arrow-down-sign-to-navigate"></i>
                    </Link>
                    <Link to="/myAccount/shopInfo" className="item-accountType">
                        <i className="icon-store"></i>
                        <span>اطلاعات فروشگاهی</span>
                        <i className="icon-arrow-down-sign-to-navigate"></i>
                    </Link>

                </div>

            </div>
        </React.Fragment>
    );
}

export default AccountType;